import { Component } from '@angular/core';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-accueil',
    templateUrl: './accueil.component.html',
    styleUrls: ['./accueil.component.scss'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent]
})
export class PageAccueilComponent {}
